import {
  Check,
  CheckSquare,
  Eye,
  GripVertical,
  Info,
  Sliders,
  Tags,
  UserPlus,
} from "@tamagui/lucide-icons";
import type { LearnAboutInfo } from "../LearnScreen";

export const CheckboxLearnMore: LearnAboutInfo[] = [
  {
    titleIcon: CheckSquare,
    title: "To-do's",
    subtitle: "Create lists and organize yourself",
    image: require("../../../../web_legacy/static/todo_card_preview.webp"),
    featureList: [
      {
        icon: Check,
        text: "1. Add as many items as needed",
      },
      {
        icon: UserPlus,
        text: "2. (Optional) If an items needs an owner, you can assign them",
      },
      {
        icon: Tags,
        text: "3. (Optional) Enable tags to categorize/filter out each item",
      },
      {
        icon: GripVertical,
        text: "4. You can reorder items at any time",
      },
      {
        icon: Eye,
        text: "5. You will always see a summary on the overview",
      },
    ],
    descriptions: [
      {
        icon: Info,
        title: "What is it?",
        description:
          "Create shared to-do lists, assign tasks, categorize with tags and track progress as every member checks off items for seamless collaborative action.",
      },

      {
        icon: Sliders,
        title: "Extra options",
        description:
          "You can ensure that completed items are sorted to the bottom to keep the list organized. Additionally, you can use labels to categorize your items, making it easy to filter and see their completion statuses.",
      },
    ],
  },
];
